export const removeNullableEntries = <T extends Record<string, unknown>>(entries: T) =>
  Object.fromEntries(
    Object.entries(entries).filter(([_, value]) => value !== null && value !== undefined),
  ) as { [K in keyof T]: Exclude<T[K], null | undefined> };
